import { Load } from "bnb-ui/dist";
import NotFound from "bnb-ui/dist/NotFound";
import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { SystemPath } from "../../utils";

const Laudo = lazy(() => import("../../pages/Laudo"));
const Home = lazy(() => import("../../pages/Home"));
const DashboardPage = lazy(() => import("../../pages/Dashboard"));
const IniciarLaudo = lazy(() => import("../../pages/Laudo/Iniciar"));
const VisualizarLaudo = lazy(() => import("../../pages/Laudo/Visualizacao"));
const VisualizarLaudoParecerTecnicoRural = lazy(() => import("../../pages/Laudo/Visualizacao/ParecerTecnicoRural"));

const LaudoRoutes = (): JSX.Element => {
	return (
		<>
			<Route exact path={SystemPath.LAUDO} render={(pr) => <Laudo {...pr} />} />
			<Route exact path={SystemPath.LAUDO_INICIAR} render={(pr) => <IniciarLaudo {...pr} />} />
			<Route exact path={SystemPath.LAUDO_VISUALIZACAO} render={(pr) => <VisualizarLaudo {...pr} />} />
			<Route exact path={SystemPath.LAUDO_VISUALIZACAO_PARECER_TECNICO_RURAL} render={(pr) => <VisualizarLaudoParecerTecnicoRural {...pr} />} />
		</>
	);
};
const renderLoader = (): JSX.Element => {
	return <Load></Load>;
};
function Main(): JSX.Element {
	return (
		<main>
			<Suspense fallback={renderLoader()}>
				<Switch>
					<Route exact path={SystemPath.HOME} component={Home} />
					<Route exact path={SystemPath.DASHBOARD} component={DashboardPage} />

					<LaudoRoutes />

					<Route component={NotFound} />
				</Switch>
			</Suspense>
		</main>
	);
}
export default Main;
